import PdfRequisicaoExames from "./PdfRequisicaoExames";

function PdfRequisicaoExamesWrapper({ showPreviousPage, requisicaoData }) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfRequisicaoExames
        requisicaoData={requisicaoData}
        showPreviousPage={showPreviousP}
      />
    </div>
  );
}

export default PdfRequisicaoExamesWrapper;
